export default {
	questions_about_the_program_find_yout_answers_here: "Dúvidas sobre o programa? Encontre suas respostas aqui."
}
